import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {MasterDataService} from '../../views/oes/services/master-data.service';
import {Subscription} from 'rxjs/Subscription';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-import-master-data-modal',
    templateUrl: './import-master-data-modal.component.html',
    styleUrls: ['./import-master-data-modal.component.scss'],
    preserveWhitespaces: true,
    providers: [
        MasterDataService
    ]
})
export class ImportMasterDataModalComponent implements OnInit, OnDestroy {

    @ViewChild('importModal') importModal: ElementRef;
    @ViewChild('header') header: ElementRef;
    @ViewChild('content') content: ElementRef;
    @ViewChild('footer') footer: ElementRef;

    public customers: Array<any>;
    public importContent: {
        customer: string,
        file: File
    };
    public fileTypes: Array<any>;
    private subscription: Subscription;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ImportMasterDataModalComponent>,
        private masterDataService: MasterDataService,
        private toastr: ToastrService
    ) { }

    ngOnInit() {
        this.customers = [];
        this.importContent = {
            customer: null,
            file: null
        };
        this.fileTypes = ['.xlsx', '.csv'];

        this.subscription = this.masterDataService.importPreload().subscribe(result => {
            if (result.success) {
                this.customers = result.data.customers.map(customer => {
                    return {
                        id: customer.CU1_ID + '_' + customer.CO1_ID,
                        name: customer.CU1_NAME,
                        disabled: Number(customer.disableField) === 1
                    };
                });
                if (this.customers.length === 1) {
                    this.importContent.customer = this.customers[0].id;
                }
            } else {
                this.closeDialog(null);
            }
        }, () => {
            this.closeDialog(null);
        });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    closeDialog(value) {
        this.dialogRef.close(value);
    }

    handleFile(target: any) {
        const files: FileList = target.files;
        if (files.length === 1) {
            const file = files.item(0);
            // (this.fileTypes.indexOf(file.type) > -1) &&
            if ((file.size <= (8 * 1024 * 1024))) {
                this.importContent.file = file;
            } else {
                this.importContent.file = null;
            }
        } else {
            this.importContent.file = null;
        }
    }

    submit() {
        if (this.importContent.customer == null || this.importContent.file == null) {
            this.toastr.error('Customer and file need to be selected.', 'Error');
        } else {
            this.closeDialog(this.importContent);
        }
    }

}


// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/import-master-data-modal/import-master-data-modal.component.ts